/* eslint-disable no-undefined */
import { ReactNode } from 'react';


type LinkProps = {
    className?: string
    href?: string
    target?: '_blank'
    children?: ReactNode
}


export const Link = ({ className, href, target, children }: LinkProps) => {
    return (
        <a
            className={ className }
            href={ href }
            target={ target }
            rel={ target === '_blank' ? 'noopener noreferrer' : undefined }
        >
            { children }
        </a>
    );
};
